import { Outlet, useLocation } from "react-router";
import { trpc } from "../../lib/trpc";
import { Loader2 } from "lucide-react";
import { UnifiedHeader } from "./UnifiedHeader";

export function DashboardLayout() {
  const location = useLocation();
  const { isLoading } = trpc.auth.me.useQuery();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  // When on the full-screen Profile Editor, edit.tsx wraps its workspace in ProfileDraftProvider
  // and renders UnifiedHeader inside the provider context for full editor action access.
  if (location.pathname === "/profile/edit") {
    return (
      <div className="h-screen w-screen overflow-hidden bg-background">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <UnifiedHeader />
      <main className="flex-1 overflow-auto bg-background">
        <Outlet />
      </main>
    </div>
  );
}
